import { DownloadItemType } from "../../types";
import { postFileRequestWrapper } from "../../utilities";

export type createVersionResponse = DownloadItemType;

type createVersionBody = {
  version_number: string;
  display_name: string | null;
  store_id: string;
  app_id: string;
};

export function createVersion(
  body: createVersionBody,
  file: File
): Promise<createVersionResponse> {
  return postFileRequestWrapper<createVersionBody, createVersionResponse>({
    url: `${ENV_SETTINGS.API_URL}/versions`,
    body,
    file,
  });
}
